import _extends from '@babel/runtime/helpers/extends';
import { __rest } from '../../../dependencies/tslib/tslib.es6.js';
import React__default from 'react';
import { iconSize } from '../../../utils/helpers.js';

/* eslint-disable max-len */

var Directory = (function (_a) {
  var _a$size = _a.size,
      size = _a$size === void 0 ? 'xs' : _a$size,
      props = __rest(_a, ["size"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({}, props, {
    width: iconSize[size],
    height: iconSize[size],
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3444 8.88889H24.6567C28.0889 8.88889 30 10.8667 30 14.2556V25.7333C30 29.1778 28.0889 31.1111 24.6567 31.1111H15.3444C11.9667 31.1111 10 29.1778 10 25.7333V14.2556C10 10.8667 11.9667 8.88889 15.3444 8.88889ZM15.6444 14.0667V14.0555H18.9655C19.4444 14.0555 19.8333 14.4444 19.8333 14.9211C19.8333 15.4111 19.4444 15.8 18.9655 15.8H15.6444C15.1655 15.8 14.7778 15.4111 14.7778 14.9333C14.7778 14.4555 15.1655 14.0667 15.6444 14.0667ZM15.6444 20.8222H24.3555C24.8333 20.8222 25.2222 20.4333 25.2222 19.9556C25.2222 19.4778 24.8333 19.0878 24.3555 19.0878H15.6444C15.1655 19.0878 14.7778 19.4778 14.7778 19.9556C14.7778 20.4333 15.1655 20.8222 15.6444 20.8222ZM15.6444 25.9H24.3555C24.7989 25.8556 25.1333 25.4767 25.1333 25.0333C25.1333 24.5778 24.7989 24.2 24.3555 24.1556H15.6444C15.3111 24.1222 14.9889 24.2778 14.8111 24.5667C14.6333 24.8444 14.6333 25.2111 14.8111 25.5C14.9889 25.7778 15.3111 25.9444 15.6444 25.9Z",
    fill: "currentColor"
  }));
});

export { Directory as default };
